import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import useQuery from "../../../../hooks/useQuery";
import { showErrorToastify } from "../../../../utils";
import { getCompra } from "../api";
import { toast } from 'react-toastify';

const useCompra = (compraId) => {
  const [unauthorized, setUnauthorized] = useState(false);
  const history = useHistory();

 const { data, refetch, loading } = useQuery({
    autoFetch: false,
    queryFn: getCompra,
    onError: (err) => {
      const originalError = err.cause || err.response || err;
      
      // chequeo un 403 que mando del back
      if (originalError?.status === 403) {
        toast.error("No tienes permisos para acceder a esta compra.");
        history.push('/unauthorized');
      } 
      // chequeo un 410 - compra cancelada
      else if (originalError?.status === 410) {
        toast.warning("Esta compra ha sido cancelada. Los tickets ya no están disponibles.", {
          position: "top-right",
          autoClose: 3000,
        });
        
        setTimeout(() => {
          history.push('/mis-compras');
        }, 3500);
      } 
      else {
        console.error("Error al obtener la compra:", err);
        toast.error("Error al cargar la compra");
      }
    },
  });

  useEffect(() => {
    if (!compraId) return;
    refetch(compraId);
  }, [compraId]);

  return {
    compra: data?.data?.compra,
    loading,
    fetchCompra: refetch,
    unauthorized,
  }
}

export default useCompra;